export default __webpack_public_path__ + "static/media/p4.5f2c9cb0.svg";